module.exports = __webpack_public_path__ + "img/aeroland-payment-hero-image.ae0d1149.png";